import { Addition } from "../../../../CommonFunction/CalculationsWithDecimalValues";

export const updateFieldInRow = (rowData, id, newValue) => {
  return rowData.map((el) => {
    if (el.id === id) {
      return { ...el, value: newValue };
    }
    return el;
  });
};

export const getFieldValue = (data, fieldName) => {
  const field = data.find((el) => el.name === fieldName);
  return field && field.value ? Number(field.value) : null;
};
export const calculateTax = (amount, rate) => {
  if (rate == 0) return amount;
  return ((rate / 100) * amount).toFixed(2);
};

export const getTotalAmount = (tableData) => {
  let TotalAmount = 0;
  Object.keys(tableData).forEach((key) => {
    // Process each element in the data array under the current key
    tableData[key].forEach((el) => {
      switch (el.name) {
        case "Tax_Amount":
          TotalAmount = Addition(TotalAmount, Number(el.value)); // Accumulate to TotalAmount

          break;
        case "Amount":
          TotalAmount = Addition(TotalAmount, Number(el.value));
          break;
      }
    });
  });
  return TotalAmount;
};
